<script>
  import { Button } from "paxray-components-svelte";
  import SearchInput from "../../settings/components/SearchInput.svelte";
  import LFilters from "../components/LFilters.svelte";
  import AnonymizationReviewControls from "./AnonymizationReviewControls.svelte";
  import { CHEVRON_LEFT_ICON, CHEVRON_RIGHT_ICON } from '@utils/icons.js';

  export let idproject;
  export let selectedProcess = "";
  export let selectedSubprocess = "";
  export let selectedTask = "";
  export let selectedSubtask = "";
  export let selectedTeam = "";
  export let selectedAssignedOption = "";
  export let selectedLevel = 0;
  export let selectedShow = "";
  export let selectedApplications = [];
  export let selectedSort = "";
  export let selectedPageSize = "10";
  export let showOptions = [];
  export let applicationOptions = [];
  export let applicationLabel = "All";
  export let sortOptions = [];
  export let pageSizeOptions = [];
  export let subtaskNavigationEnabled = false;
  export let extraSubtaskOptions = [];
  export let onNavigateSubtask = () => {};
  export let onSearch = () => {};
  export let searchValue = "";
</script>

<div class="filter-bar control-toolbar">
  <LFilters
    {idproject}
    bind:selectedProcess
    bind:selectedSubprocess
    bind:selectedTask
    bind:selectedSubtask
    bind:selectedTeam
    bind:selectedAssignedOption
    {extraSubtaskOptions}
    showTeam={false}
    showReset={false}
  >
    <div slot="before-filters" class="before-filters">
      <AnonymizationReviewControls
        bind:selectedLevel
        bind:selectedShow
        bind:selectedApplications
        bind:selectedSort
        bind:selectedPageSize
        {showOptions}
        {applicationOptions}
        {applicationLabel}
        {sortOptions}
        {pageSizeOptions}
      />
    </div>
    <div slot="after-subtask-filter" class="subtask-navigation">
      <Button
        size="field"
        kind="secondary"
        icon={CHEVRON_LEFT_ICON}
        iconDescription={subtaskNavigationEnabled
          ? "Previous L4"
          : "No other L4 available"}
        ariaLabel="Previous L4"
        disabled={!subtaskNavigationEnabled}
        on:click={() => onNavigateSubtask(-1)}
      />
      <Button
        size="field"
        kind="secondary"
        icon={CHEVRON_RIGHT_ICON}
        iconDescription={subtaskNavigationEnabled ? "Next L4" : "No other L4 available"}
        ariaLabel="Next L4"
        disabled={!subtaskNavigationEnabled}
        on:click={() => onNavigateSubtask(1)}
      />
    </div>
    <div slot="after-reset" class="search-field">
      <SearchInput
        bind:value={searchValue}
        on:search={(event) => onSearch(event.detail)}
      />
    </div>
  </LFilters>
</div>

<style>
  .filter-bar {
    width: auto;
    min-width: 0;
    margin-right: -1.19rem;
    margin-left: -0.88rem;
    padding: 0 1.19rem var(--control-gap) 0.88rem;
    border-bottom: 1px solid var(--border-color);
  }
  .filter-bar :global(.filter_wrapper) {
    display: flex;
    width: 100%;
    min-width: 0;
    align-items: flex-end;
    gap: var(--control-gap);
    flex-wrap: wrap;
    overflow: visible;
  }
  .filter-bar :global(.hierarchical-filter) {
    width: 20ch;
    min-width: 20ch;
  }
  .filter-bar :global(.hierarchical-filter .custom_select),
  .filter-bar :global(.hierarchical-filter .bx--select-input),
  .filter-bar :global(.hierarchical-filter .bx--select-input__wrapper) {
    width: 20ch !important;
    max-width: 20ch;
    min-width: 0;
  }
  .filter-bar :global(.hierarchical-filter .bx--select-input) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .before-filters {
    display: contents;
  }
  .subtask-navigation {
    display: flex;
    gap: var(--control-gap);
  }
  .search-field {
    align-self: flex-end;
    flex: 1 1 16rem;
    width: min(24rem, 100%);
    min-width: 12rem;
  }
  .search-field :global(.search-input) {
    box-sizing: border-box;
    height: 2.5rem;
    padding: 0 0.5rem;
  }
  .search-field :global(.search-input input) {
    width: 100%;
    min-width: 0;
  }
</style>
